import { render, staticRenderFns } from "./bmRegister.vue?vue&type=template&id=3fac7427&scoped=true"
import script from "./bmRegister.vue?vue&type=script&lang=js"
export * from "./bmRegister.vue?vue&type=script&lang=js"
import style0 from "./bmRegister.vue?vue&type=style&index=0&id=3fac7427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac7427",
  null
  
)

export default component.exports